<script setup lang="ts">
import History from "@/views/playground/planner/business-management/service-management/information/History.vue";
</script>

<template>
  <history></history>
</template>

<style scoped></style>
